const translation = {
  toVerifiedTip: {
    coupon: 'คูปองพิเศษ 100%',
    end: 'สำหรับแผนมืออาชีพของ Dify.',
    front: 'คุณมีสิทธิ์ได้รับสถานะการตรวจสอบการศึกษาแล้ว กรุณากรอกข้อมูลการศึกษาของคุณด้านล่างเพื่อดำเนินการให้เสร็จสิ้นและรับสิทธิ์',
  },
  form: {
    schoolName: {
      title: 'ชื่อโรงเรียนของคุณ',
      placeholder: 'กรุณาใส่ชื่อของโรงเรียนอย่างเป็นทางการที่ไม่มีการย่อ',
    },
    schoolRole: {
      option: {
        student: 'นักเรียน',
        teacher: 'ครู',
        administrator: 'ผู้ดูแลโรงเรียน',
      },
      title: 'บทบาทของคุณในโรงเรียน',
    },
    terms: {
      desc: {
        front: 'ข้อมูลของคุณและการใช้สถานะการตรวจสอบการศึกษาอยู่ภายใต้เงื่อนไขของเรา',
        end: '. โดยการส่ง:',
        privacyPolicy: 'นโยบายความเป็นส่วนตัว',
        and: 'และ',
        termsOfService: 'ข้อกำหนดในการให้บริการ',
      },
      option: {
        age: 'ฉันยืนยันว่าฉันมีอายุอย่างน้อย 18 ปี',
        inSchool: 'ฉันยืนยันว่าฉันได้ลงทะเบียนหรือทำงานที่สถาบันที่ระบุไว้ Dify อาจขอหลักฐานการลงทะเบียน/การจ้างงาน หากฉันแสดงความไม่ถูกต้องเกี่ยวกับคุณสมบัติของฉัน ฉันตกลงที่จะชำระค่าธรรมเนียมใด ๆ ที่ถูกยกเว้นไปในเบื้องต้นตามสถานะการศึกษาของฉัน.',
      },
      title: 'ข้อกำหนดและเงื่อนไข',
    },
  },
  toVerified: 'ตรวจสอบการศึกษา',
  rejectTitle: 'การตรวจสอบการศึกษา Dify ของคุณถูกปฏิเสธ',
  emailLabel: 'อีเมลปัจจุบันของคุณ',
  currentSigned: 'ลงชื่อเข้าใช้ในฐานะ',
  successTitle: 'คุณได้รับการรับรองการศึกษา Dify',
  learn: 'เรียนรู้วิธีการตรวจสอบการศึกษา',
  submitError: 'การส่งแบบฟอร์มล้มเหลว โปรดลองอีกครั้งในภายหลัง.',
  submit: 'ส่ง',
  successContent: 'เราได้ออกคูปองส่วนลด 100% สำหรับแผน Dify Professional ให้กับบัญชีของคุณ คูปองนี้สามารถใช้ได้เป็นระยะเวลา 1 ปี กรุณาใช้ภายในช่วงระยะเวลาที่กำหนด.',
  rejectContent: 'น่าเสียดายที่คุณไม่มีสิทธิ์ได้รับสถานะการตรวจสอบการศึกษาและดังนั้นคุณจึงไม่สามารถรับคูปองพิเศษ 100% สำหรับแผนมืออาชีพ Dify หากคุณใช้ที่อยู่อีเมลนี้.',
}

export default translation
